export default __webpack_public_path__ + "static/media/logo-cvc.6e769a3e.jpg";